export const COLORS = [
    "#FF6B6B", // Coral Red
    "#00A896", // Teal
    "#3A86FF", // Vivid Blue
    "#FFBE0B", // Vivid Yellow
    "#8338EC", // Vivid Purple
    "#FB5607", // Vivid Orange
    "#FF006E", // Pink
    "#118AB2", // Deep Sky Blue
    "#06D6A0", // Mint Green
    "#FFD166", // Soft Yellow
    "#EF476F", // Red Pink
    "#2D6A7E", // Soft Navy
    "#FF9F1C", // Vivid Tangerine
    "#A259FF", // Soft Purple
    "#2EC4B6", // Turquoise Green
    "#E71D36", // Crimson Red
    "#3F88C5", // Calm Blue
];

export const BADGE_COLORS = [
    { bg: "#BBDEFB", border: "#2196F3", text: "#1565C0" }, // Blue
    { bg: "#E1BEE7", border: "#9C27B0", text: "#7B1FA2" }, // Purple
    { bg: "#C8E6C9", border: "#4CAF50", text: "#388E3C" }, // Green
    { bg: "#FFE0B2", border: "#FF9800", text: "#F57C00" }, // Orange
    { bg: "#F8BBD0", border: "#E91E63", text: "#C2185B" }, // Pink
    { bg: "#B2DFDB", border: "#009688", text: "#00695C" }, // Teal
    { bg: "#DCEDC8", border: "#8BC34A", text: "#689F38" }, // Light Green
    { bg: "#FFECB3", border: "#FFC107", text: "#FF8F00" }, // Amber
    { bg: "#C5CAE9", border: "#3F51B5", text: "#303F9F" }, // Indigo
    { bg: "#FFCCBC", border: "#FF5722", text: "#D84315" }, // Deep Orange
    { bg: "#B2EBF2", border: "#00BCD4", text: "#00838F" }, // Cyan
    { bg: "#D1C4E9", border: "#673AB7", text: "#512DA8" }, // Deep Purple
];
